import * as v from 'valibot';

import type { CaseLegTracking, CaseTrackingResponse } from '../../model';

// `v.nullable`, never `v.optional`: the BE always sends every field, null when
// unknown, and a wrong schema drops live data QUIETLY.

const coordinateSchema = v.object({
  latitude: v.number('Tracking latitude is missing'),
  longitude: v.number('Tracking longitude is missing'),
});

const endpointSchema = v.object({
  coordinate: v.nullable(coordinateSchema),
  isComplete: v.nullable(v.boolean()),
});

const currentPositionSchema = v.object({
  coordinate: coordinateSchema,
  heading: v.nullable(v.number()),
  timestamp: v.string('Tracking position timestamp is missing'),
});

export const caseLegTrackingSchema: v.GenericSchema<CaseLegTracking> = v.object(
  {
    legId: v.string('Tracked leg id is missing'),
    type: v.picklist(['Ground', 'Air'], 'Tracked leg type is unrecognised'),
    departure: endpointSchema,
    arrival: endpointSchema,
    std: v.nullable(v.string()),
    atd: v.nullable(v.string()),
    sta: v.nullable(v.string()),
    eta: v.nullable(v.string()),
    currentPosition: v.nullable(currentPositionSchema),
    plannedPolyline: v.nullable(v.string()),
    trackedPolyline: v.nullable(v.string()),
  },
);

export const caseTrackingDataSchema: v.GenericSchema<CaseTrackingResponse> =
  v.object({
    caseId: v.string('Tracking case id is missing'),
    legs: v.array(caseLegTrackingSchema),
  });

export const caseTrackingResponseSchema = v.object({
  data: caseTrackingDataSchema,
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  dataGeneratedAt: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});
